import React from 'react';
import PropTypes from 'prop-types';

const ArrowRight = ({ color, size, className }) => (
  <svg
    stroke="currentColor"
    fill="currentColor"
    strokeWidth="0"
    viewBox="0 0 24 24"
    height="1em"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
    color={color}
    fontSize={size}
    className={className}
  >
    <path d="M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z" />
  </svg>
);

ArrowRight.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
  size: PropTypes.number,
};
  
ArrowRight.defaultProps = {
  className: '',
  color: '#333333',
  size: 13
};

export default ArrowRight;
